define((require) => {
    "use strict";

    const $                  = require("jquery");
    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering a link widget.
     *
     * @class LinkWidgetView
     * @constructor
     *
     * @cfg {LinkWidgetModel} model The model of the link widget being rendered.
     */
    return AbstractWidgetView.extend("LinkWidget", {

        _$placeholderElement: null,

        className: `${AbstractWidgetView.prototype.className} link-widget`,

        updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    this._$placeholderElement = $("<div class='placeholder'></div>")
                        .appendTo(element);
                }
            } else {
                // IE 10 and below does not handle overlayed widgets correctly unless they have
                // a background.
                element.css({
                    backgroundColor: "#fff",
                    opacity: 0
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/linkWidget/LinkWidgetView.js